import { createSelector } from 'reselect';
import { iDeviceDetails, iDevicePing, iDevicePingEager, iDevicePingWithGeofences, iDevicePingWithGeofencesEager, iFullStoreState, iList, iPerson, ItemType, iTrip, iTripEager } from "../../shared/interfaces";
import { groupBy } from "ramda";
import { selectPeople } from './general-selectors';
import { selectDevices } from './devicesData/selector';
import { pipe, map } from 'ramda';
import { Map } from "immutable";

export const selectDisplayRecords = (s: iFullStoreState): iList<iDevicePing | iTrip> => s.report.displayRecords;
export const selectDeviceOrPerson = (s: iFullStoreState): ItemType.device | ItemType.person => s.report.details.devicePerson;

export const selectReportsGrouped = createSelector(
    [selectDisplayRecords, selectDeviceOrPerson],
    (displayRecords, deviceOrPerson): iList<iDevicePing[] | iTrip[] | iDevicePingWithGeofences[]> => {
        return groupBy((x: iDevicePing | iTrip | iDevicePingWithGeofences) => deviceOrPerson === ItemType.device ? x.device : x.personId)(Object.values(displayRecords || {}));
    }
);

export const selectPeopleToSendReportKeys = (s: iFullStoreState): iList<boolean> => s.report.details.peopleToSendReport;

export const selectPeopleToSendEmail = createSelector(
    [selectPeople, selectPeopleToSendReportKeys],
    (people: iList<iPerson>, peopleToSendReportKeys): iList<iPerson> => {
        const res = {};
        Object.keys(peopleToSendReportKeys).forEach(key => {
            res[key] = people[key];
        })
        return res;
    }
)

export const selectCustomEmailsToSendReport = (s: iFullStoreState): string[] => s.report.details.customEmailsToSendReport;

export const selectAllEmailsToSendReport = createSelector(
    [selectPeopleToSendEmail, selectCustomEmailsToSendReport],
    (people: iList<iPerson>, emails: string[]): string[] => {
        return [...Object.values(people).map((p: iPerson) => p.email), ...emails];
    }
)

export const selectReportsEager = createSelector(
    [selectDisplayRecords, selectPeople, selectDevices],
    (records: iList<iDevicePing | iTrip | iDevicePingWithGeofencesEager> = {}, people: iList<iPerson>, devices: Map<string, iDeviceDetails>): Array<iDevicePingEager | iTripEager | iDevicePingWithGeofencesEager> => {
        console.log("i am here motherfucker", records)
        return pipe(
            Object.values,
            map((record) => ({...record, device: devices.getIn([record.device]) as iDeviceDetails, person: people[record.personId]})),
        )(records);
    }
)
